import {CasinoLegacyDeepLinkActionBase} from '../casino-legacy-deep-link-action-base';

export abstract class PlayGameDeepLinkActionBase extends CasinoLegacyDeepLinkActionBase {

  protected abstract getIsRealMode(): boolean;

  // Play Game never execute the next action
  async execute(): Promise<void> {

    const gameType = this._getGameType();

    if(!gameType) {
      return;
    }

    await this.services.messageBroker.channels.performAction.topics.openCasinoGame.execute({
      actionData: {
        gameType: gameType,
        isReal: this.getIsRealMode()
      }
    });
  }


  private _getGameType(): number | null | undefined {
    if(!this.descriptor.actionParams && !this.descriptor.actionParams.id) {
      this.services.logger.error('No parameters were specified for play game deep link action');
      return null;
    }
    let gameTypes = this.descriptor.actionParams.id.toString().split(',').map(gameType => gameType.trim());

    if(gameTypes.length === 1) {
      return parseInt(gameTypes[0]);
    }

    if(gameTypes.length > 1) {
      if(this.services.device.os.isMobileOS) {
        return parseInt(gameTypes[1]);
      } else {
        return parseInt(gameTypes[0]);
      }
    }
  }


}
